module.exports = __webpack_public_path__ + "img/Picture18.519a4c8a.png";